// extracted by mini-css-extract-plugin
export var aggregationCell = "_2s-n";
export var aggregationRow = "_2s-m";
export var borderlessSpinnerContainer = "_2s-3";
export var cardLayout = "_2s-6";
export var cardLayoutNoFooter = "_2s-9";
export var cardLayoutPageControl = "_2s-8";
export var closeIcon = "_2s-f";
export var columnHeaderSurface = "_2s-b";
export var columnHeaderSurfaceDragOverlay = "_2s-v";
export var columnHeaderSurfaceResizing = "_2s-s";
export var contextMenuAnchor = "_2s-1";
export var draggableColumnHeader = "_2s-t";
export var draggableColumnHeaderOverlay = "_2s-u";
export var expandIcon = "_2s-g";
export var expanded = "_2s-h";
export var filterDropdown = "_2s-i";
export var filterDropdownDivider = "_2s-d";
export var filterDropdownHeader = "_2s-l";
export var filterDropdownItem = "_2s-k";
export var filterDropdownModal = "_2s-j _2s-i";
export var filterItem = "_2s-c";
export var normalCellWithAdjustableBorder = "_2s-e";
export var pinButtonContainer = "_2s-o";
export var pinIcon = "_2s-p";
export var pinIconActive = "_2s-q";
export var spinner = "_2s-0";
export var spinnerContainer = "_2s-2";
export var tableContainer = "_2s-4";
export var tableContentDraggingColumns = "_2s-a";
export var tableContentInner = "_2s-7";
export var tableContentWrapper = "_2s-5";
export var viewButtonContainer = "_2s-r";